"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RegistrationFinalizationRequestDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const enums_1 = require("../../enums");
class RegistrationFinalizationRequestDto {}
exports.RegistrationFinalizationRequestDto = RegistrationFinalizationRequestDto;
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.Gender
}), __metadata("design:type", String)], RegistrationFinalizationRequestDto.prototype, "gender", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.SubGender,
  required: false,
  description: 'Optional sub-gender; must belong to the selected gender when provided.'
}), __metadata("design:type", String)], RegistrationFinalizationRequestDto.prototype, "subGender", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  description: 'Whether to show gender preferences on the profile. Defaults to true.'
}), __metadata("design:type", Boolean)], RegistrationFinalizationRequestDto.prototype, "showGenderPreferences", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Date of birth in MM-DD-YYYY format',
  required: false
}), __metadata("design:type", String)], RegistrationFinalizationRequestDto.prototype, "dateOfBirth", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.Gender
}), __metadata("design:type", String)], RegistrationFinalizationRequestDto.prototype, "preferredGender", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: [String],
  enum: enums_1.Gender
}), __metadata("design:type", Array)], RegistrationFinalizationRequestDto.prototype, "preferredGenders", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: 'string',
  format: 'binary',
  description: 'Avatar image file (JPEG, JPG, PNG)'
}), __metadata("design:type", Object)], RegistrationFinalizationRequestDto.prototype, "avatar", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: 'string',
  description: 'Blurred avatar image'
}), __metadata("design:type", String)], RegistrationFinalizationRequestDto.prototype, "blurredAvatar", void 0);
//# sourceMappingURL=RegistrationFinalizationRequest.dto.js.map